<template>
  <div :class="`formulate-input-element`">
   <div class="chosen-vehicle-block">
       <div class="plate">{{ getAnswer('plate','vehicle_plate') }}</div>
       <div class="full_model">{{ getAnswer('plate','vehicle_year') }} {{ getAnswer('plate','vehicle_make') }} {{ getAnswer('plate','vehicle_model') }}</div>
   </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
  },
  data () {
    return {
    }
  },
  watch: {
    model () {
    }
  },
  computed: {
    ...mapGetters({ answers: 'flattenedAnswers', getAnswer: 'getAnswer' }),
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">

.chosen-vehicle-block {
    border:1px solid rgba(231, 241, 255, 1);
    background:rgba(245, 255, 255, 1);
    border-radius:4px;
    padding:0.8rem 1rem;
}

</style>

<style lang="scss">

.chosen-vehicle-block {
    display:flex;
    justify-content: left;
    align-items: center;

    .plate {
        text-transform:uppercase;
        font-family: 'NZ Licence Plate';
        font-size:1.15rem;
        color:rgba(48, 48, 48, 1);
        padding:0.15rem 0.3rem;
        min-width:4.5rem;
        text-align: center;
        line-height:1.4rem;
        border-radius:4px;
        background:rgba(255, 255, 255, 1);
        border: 1px solid rgba(48, 48, 48, 0.6);
        position:relative;
        margin-right:1rem;

        box-shadow: 0 0 0 1px white;

        // &:before {
        //   content:"";
        //   position:absolute;
        //   top:1px;
        //   left:1px;
        //   width:calc(100% - 2px);
        //   height:calc(100% - 2px);
        //   border-radius:4px;
        //   border:1px solid rgba(48, 48, 48, 0.6);
        // }
    }

    .make {
        width:64px;
        height:48px;
        background-size:contain;
        background-position:center center;
        background-repeat:no-repeat;
    }
}



</style>